import { render, staticRenderFns } from "./ReleasesBudgetEditPanelDialog.vue?vue&type=template&id=4f4e66e6"
import script from "./ReleasesBudgetEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./ReleasesBudgetEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports